/**
 * User: WangMeng
 * Date: 2018-04-16
 * Time: 9:46
 * Desc: 公司筛选
 */

import commonStyles from '../common/common.scss';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Col, Form, Input, Row, Select } from 'antd';
import { COMPARE_OPTIONS } from '../../../../constants/common';
import LabelList from '../../../common/labelList/LabelList';
import { isNumber, getChildOptions } from '../../../../utils/util';
const FormItem = Form.Item;
const Option = Select.Option;
const LabelItem = LabelList.Item;

class FilterSearchForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            compareOptions: [...COMPARE_OPTIONS],
            options: {},
            subAnaTypeOptions: [],
            industrySecLevelOptions: []
        };
    }

    componentDidMount() {
        this.setOptions();
    }

    componentWillReceiveProps(nextProps) {
        this.setOptions(nextProps);
    }

    setOptions = (props = this.props) => {
        const { options } = props;
        if (this.initialized || !options) {
            return;
        }
        this.initialized = true;
        this.setState({ options, subAnaTypeOptions: options.riskFakeTypes[0] && options.riskFakeTypes[0].childs || [] });
    };

    resetSubFields = (field, v) => {
        const { options } = this.state;
        let state = null, subFiles = '';
        switch (field){
            case 'anaType': // 财务指标
                state = { subAnaTypeOptions: getChildOptions(v, options.riskFakeTypes) };
                subFiles = 'subAnaType,lastYearSubAnaType';
                break;
            case 'industryTopLevelCode': // 行业
                state = { industrySecLevelOptions: getChildOptions(v, options.industries) };
                subFiles = 'industrySecLevelCode';
                break;
            default:
                break;
        }
        if (state || subFiles) {
            this.setState(state, () => this.props.form.resetFields(subFiles.split(',')));
        }
    };

    numberValid = (min = 0, max) => {
        return (rule, value, callback) => {
            if (value) {
                let n = Number(value);
                if (!isNumber(n)) {
                    return callback(' ');
                }
                if (n < min) {
                    return callback(' ');
                }
                if (max !== undefined &&  n > max) {
                    return callback(' ');
                }
                callback();
            }
            callback();
        };
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { onSearch } = this.props;
        const { validateFields } = this.props.form;

        validateFields({ force: true }, (err, values) => {
            if (!err) {
                onSearch && onSearch(values);
            }
        });
    };

    render() {
        const { className } = this.props;
        const { getFieldDecorator } = this.props.form;
        const { options, compareOptions, subAnaTypeOptions, industrySecLevelOptions } = this.state;
        const { reportYear = [], reportDateType = [], reportType = [], riskFakeTypes = [], financeIndicators = [], industries = [], province = [] } = options;

        return (
            <div className={classNames('search-bar', commonStyles.searchBar, className)}>
                <Form hideRequiredMark layout="inline" onSubmit={this.onSubmit}>
                    <Row>
                        <Col span={13}>
                            <LabelList>
                                <LabelItem label="财报年份">
                                    <FormItem>
                                        {getFieldDecorator('reportYear', {
                                            initialValue: ''
                                        })(
                                            <Select size="default">
                                                <Option value="">全部</Option>
                                                { reportYear.map(d => <Option key={d} value={d}>{d}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        {getFieldDecorator('reportDateType', {
                                            initialValue: ''
                                        })(
                                            <Select size="default">
                                                <Option value="">全部</Option>
                                                { reportDateType.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem className="hide">
                                        {getFieldDecorator('reportType', {
                                            initialValue: reportType[0] && reportType[0].key
                                        })(
                                            <Select size="default">
                                                <Option value="">全部</Option>
                                                { reportType.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                </LabelItem>
                                <LabelItem label="财报类型">
                                    <FormItem>
                                        {getFieldDecorator('anaType', {
                                            initialValue: riskFakeTypes[0] && riskFakeTypes[0].key
                                        })(
                                            <Select size="default" onChange={(v) => this.resetSubFields('anaType', v)}>
                                                { riskFakeTypes.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <br />
                                    <FormItem>
                                        {getFieldDecorator('subAnaType', {
                                            initialValue: subAnaTypeOptions[0] && subAnaTypeOptions[0].key
                                        })(
                                            <Select size="default">
                                                { subAnaTypeOptions.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        {getFieldDecorator('anaCompareOperator', {
                                            initialValue: compareOptions[0].key
                                        })(
                                            <Select size="default">
                                                { compareOptions.map(d => <Option key={d.key} value={d.key}>分值{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        {getFieldDecorator('anaScore', {
                                            rules: [{
                                                validator: this.numberValid(0, 1)
                                            }],
                                            initialValue: ''
                                        })(
                                            <Input placeholder="请输入0-1之间分值"/>
                                        )}
                                    </FormItem>
                                    <br/>
                                    <FormItem>
                                        {getFieldDecorator('lastYearSubAnaType', {
                                            initialValue: subAnaTypeOptions[0] && subAnaTypeOptions[0].key
                                        })(
                                            <Select size="default">
                                                { subAnaTypeOptions.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        {getFieldDecorator('lastYearAnaCompareOperator', {
                                            initialValue: compareOptions[0].key
                                        })(
                                            <Select size="default">
                                                { compareOptions.map(d => <Option key={d.key} value={d.key}>分值{d.value}去年变化</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        {getFieldDecorator('lastYearAnaScorePercent', {
                                            rules: [{
                                                validator: this.numberValid()
                                            }],
                                            initialValue: ''
                                        })(
                                            <Input placeholder="请输入百分比值"/>
                                        )}
                                        &nbsp;<span>%</span>
                                    </FormItem>
                                </LabelItem>
                            </LabelList>
                        </Col>
                        <Col span={11}>
                            <LabelList>
                                <LabelItem label="所属行业">
                                    <FormItem>
                                        {getFieldDecorator('industryTopLevelCode', {
                                            initialValue: ''
                                        })(
                                            <Select size="default" onChange={(v) => this.resetSubFields('industryTopLevelCode', v)}>
                                                <Option value="">全部</Option>
                                                { industries.map(d => <Option key={d.key} value={d.key} title={d.value}>{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        {getFieldDecorator('industrySecLevelCode', {
                                            initialValue: ''
                                        })(
                                            <Select size="default">
                                                <Option value="">全部</Option>
                                                { industrySecLevelOptions.map(d => <Option key={d.key} value={d.key} title={d.value}>{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                </LabelItem>
                                <LabelItem label="所属省份">
                                    <FormItem>
                                        {getFieldDecorator('provinceCode', {
                                            initialValue: ''
                                        })(
                                            <Select size="default" >
                                                <Option value="">全国</Option>
                                                { province.map(d => <Option key={d.key} value={d.key} title={d.value}>{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                </LabelItem>
                                <LabelItem label="财务指标">
                                    <FormItem>
                                        {getFieldDecorator('financialTargetType', {
                                            initialValue: financeIndicators[0] && financeIndicators[0].key
                                        })(
                                            <Select size="default">
                                                { financeIndicators.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <br />

                                    <FormItem>
                                        {getFieldDecorator('financialTargetQuantileCompareOperator', {
                                            initialValue: compareOptions[0].key
                                        })(
                                            <Select size="default">
                                                { compareOptions.map(d => <Option key={d.key} value={d.key}>分位数{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        {getFieldDecorator('financialTargetQuantileValue', {
                                            rules: [{
                                                validator: this.numberValid(0, 1)
                                            }],
                                            initialValue: ''
                                        })(
                                            <Input placeholder="请输入0-1之间的小数"/>
                                        )}
                                    </FormItem>
                                    <br/>
                                    <FormItem>
                                        {getFieldDecorator('financialTargetCompareOperator', {
                                            initialValue: compareOptions[0].key
                                        })(
                                            <Select size="default">
                                                { compareOptions.map(d => <Option key={d.key} value={d.key}>数值{d.value}</Option>) }
                                            </Select>
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        {getFieldDecorator('financialTargetValue', {
                                            rules: [{
                                                validator: this.numberValid()
                                            }],
                                            initialValue: ''
                                        })(
                                            <Input placeholder="请输入数值"/>
                                        )}
                                    </FormItem>
                                    <FormItem>
                                        <button type="submit" className={classNames('btn btn-blue')}>搜索</button>
                                    </FormItem>
                                </LabelItem>
                            </LabelList>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

export default (Form.create({})(FilterSearchForm));



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/company/FilterSearchForm.jsx